import { TextField, Typography, Box } from "@mui/material";

export function TextAnswer({ label, value = "" }) {
  return (
    <Box mb={2}>
      <Typography fontWeight="medium" mb={0.5}>
        {label}
      </Typography>
      <TextField
        fullWidth
        size="small"
        value={value}
        variant="outlined"
        maxRows={3}
      />
    </Box>
  );
}
